import api from './api';

export type ContactCategory =
  | 'technical'
  | 'content'
  | 'account'
  | 'feedback'
  | 'partnership'
  | 'other';

export interface ContactMessage {
  name: string;
  email: string;
  category: ContactCategory;
  subject: string;
  message: string;
  pageUrl?: string;
  website?: string;
}

export interface ContactResponse {
  success: true;
  referenceId: string;
  message: string;
}

export const contactService = {
  send(message: ContactMessage): Promise<ContactResponse> {
    return api.post('/contact', message);
  },
};
